import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Jobs from "./pages/Jobs";
import JobCreate from "./pages/JobCreate";
import JobDetail from "./pages/JobDetail";
import QuestionBank from "./pages/QuestionBank";
import Credits from "./pages/Credits";
import BuyCredits from "./pages/BuyCredits";
import Settings from "./pages/Settings";
import CandidateInvite from "./pages/CandidateInvite";
import InterviewComplete from "./pages/InterviewComplete";

// Business hiring console — mounted as a DESCENDANT route tree at /business/*
// inside the consumer app's single BrowserRouter, so the whole product
// (marketing + student app + institution console + business console + API) runs
// on one origin/port. It keeps its OWN auth context: a localStorage bearer token
// (prepxai_biz_token), separate from both the consumer's cookie session and the
// institution key, so the three trust boundaries never leak into each other.
//
// Child route paths are RELATIVE (no leading slash) — React Router resolves them
// under the parent "/business/*" match. All in-app navigation targets are written
// with an explicit "/business" prefix (see pages/components). Jobs + single-round
// hiring land in Phase 3; the multi-round pipeline scheduler + a dedicated
// candidates view arrive in Phase 4, shown as "Soon" in the nav until then.
export default function BusinessApp() {
  return (
    <AuthProvider>
      {/* business-scope neutralizes the app-wide fluid-type font inflation so the
          console's text renders at the same scale as the rest of the app (see
          .business-scope rules in styles/tailwind.css). */}
      <div className="business-scope">
        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />

          {/* PUBLIC candidate portal — the opaque invite token is the credential,
              so these sit OUTSIDE ProtectedRoute (no console login). The invite
              path mirrors the emailed link: /business/invite/:token. The
              thank-you is where the interview flow diverts a candidate on
              completion (see pages/generating-result). Candidates never see a
              score/report here or anywhere. */}
          <Route path="invite/:token" element={<CandidateInvite />} />
          <Route path="interview-complete" element={<InterviewComplete />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="jobs/new" element={<JobCreate />} />
              <Route path="jobs/:jobId" element={<JobDetail />} />
              <Route path="question-bank" element={<QuestionBank />} />
              <Route path="credits" element={<Credits />} />
              <Route path="buy-credits" element={<BuyCredits />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/business" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}
